<template lang="pug">
  .site-container
    .b-new-password-page.empty-page
      ._container.empty-page-container
        AuthPasswordResetFrom._content.empty-page-content
        AuthFooter
</template>

<script>
import AuthPasswordResetFrom from '@/components/AuthPasswordResetFrom.vue';
import AuthFooter from '@/components/AuthFooter.vue';

export default {
  components: { AuthPasswordResetFrom, AuthFooter },
};
</script>

<style lang="scss" scoped>
.new-password-page {
  &__content {
    flex-direction: column;
    padding: 66px 207px;
  }

  &__input {
    margin-bottom: 16px;
  }

  @media (max-width: 1024px) {
    &__content {
      padding: 66px 26.40625vw;
    }
  }

  @media (max-width: 768px) {
    &__content {
      padding: 66px 15.9895833333vw;
    }
  }

  @media (max-width: 500px) {
    &__container {
      width: 100%;
    }

    &__content {
      padding: 66px 20px;
    }
  }
}
</style>
